/*
 * <product-meta-tabs> — the "Dimensions | Details" strip under the product
 * title. Deliberately not the theme's <tabs-component>: that one always starts
 * on the first tab and swaps panels through an animation promise, while here
 * the initially selected tab is whichever one the Liquid marked
 * aria-selected="true", and the swap has to be instant.
 *
 * The server renders the correct initial state (one tab selected, the other
 * panels hidden), so there is nothing to do on load beyond wiring the clicks.
 */
if (!customElements.get('product-meta-tabs')) {
  customElements.define(
    'product-meta-tabs',
    class ProductMetaTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = this.tabs.map((tab) => this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeyDown(event, index));
        });
      }

      onKeyDown(event, index) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

        event.preventDefault();
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const next = (index + offset + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          if (this.panels[i]) this.panels[i].hidden = !isActive;
        });
      }
    }
  );
}
